'use strict';

const Answers = require('./answers'),
    SiteAnswer = require('../models/siteAnswer');

const SiteAnswers = Answers.extend({
    model: SiteAnswer
});

module.exports = SiteAnswers;